export default __webpack_public_path__ + "static/media/dropdownArrow.08ff6c2c.svg";